import {
  ChartColumn,
  ChevronDown,
  FileText,
  LayoutDashboard,
  List,
  LogOut,
  MapPin,
  Settings,
  SquareCheck,
  UserCheck,
  Users,
  X,
} from "lucide-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/login/teletrace-logo-white.png";
import { clearUser } from "../redux/users/usersSlice";
import classes from "./Sidebar.module.css";

const ICON_SIZE = 22;
const ICON_STROKE = 1.75;

const navItems = [
  { icon: LayoutDashboard, label: "Dashboard", to: "/dashboard" },
  { icon: Users, label: "Clients", to: "/clients" },
  { icon: UserCheck, label: "Staff", to: "/staff" },
  { icon: MapPin, label: "Community Visits", to: "/visits" },
  { icon: SquareCheck, label: "Validate", to: "/validate" },
  { icon: FileText, label: "Encounter Forms", to: "/encounter-forms" },
  { icon: ChartColumn, label: "Reports", to: "/reports" },
  { icon: List, label: "Activity Logs", to: "/activity-logs" },
  { icon: Settings, label: "Settings", to: "/settings" },
];

const Sidebar = ({ isOpen = false, onClose }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.user);
  const organizationName =
    user?.username || localStorage.getItem("username") || "Organization";
  const roleLabel = "Org Admin";

  useEffect(() => {
    if (typeof onClose === "function") onClose();
  }, [location.pathname]);

  const handleSignOut = () => {
    dispatch(clearUser());
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <button
        aria-label="Close navigation"
        className={`${classes.backdrop} ${isOpen ? classes.backdropOpen : ""}`}
        onClick={onClose}
        type="button"
      />
      <aside className={`${classes.sidebar} ${isOpen ? classes.sidebarOpen : ""}`}>
        <div className={classes.top}>
          <div className={classes.logoRow}>
            <Link className={classes.logoLink} to="/dashboard">
              <img alt="TeleTrace" className={classes.logo} src={logo} />
            </Link>
            <button
              aria-label="Close navigation"
              className={classes.closeButton}
              onClick={onClose}
              type="button"
            >
              <X color="#9FB6C4" size={20} strokeWidth={2} />
            </button>
          </div>

          <button className={classes.orgCard} type="button">
            <div className={classes.orgText}>
              <span className={classes.orgName}>{organizationName}</span>
              <span className={classes.orgRole}>{roleLabel}</span>
            </div>
            <ChevronDown color="#9FB6C4" size={16} strokeWidth={1.75} />
          </button>

          <nav className={classes.nav}>
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${classes.link} ${classes.linkActive}` : classes.link
                  }
                  key={item.to}
                  to={item.to}
                >
                  {({ isActive }) => (
                    <>
                      <span className={classes.icon}>
                        <Icon
                          color={isActive ? "#27B99A" : "#9FB6C4"}
                          size={ICON_SIZE}
                          strokeWidth={ICON_STROKE}
                        />
                      </span>
                      <span>{item.label}</span>
                    </>
                  )}
                </NavLink>
              );
            })}
          </nav>
        </div>

        <button className={classes.signOut} onClick={handleSignOut} type="button">
          <LogOut color="#9FB6C4" size={20} strokeWidth={ICON_STROKE} />
          Sign Out
        </button>
      </aside>
    </>
  );
};

export default Sidebar;
